import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import { makeStyles } from 'tss-react/mui';
import Typography from '@mui/material/Typography';
import { nameFromCC, slugFromCC } from 'tf-post-parser';
import shadow from '../../helpers/shadow';
import Link from '@mui/material/Link';
import CountryEmoji from './CountryEmoji';
import Image from 'components/FutureImage';
import imageCrop from 'helpers/imageCrop';

export default function DestinationItem({ destination, isPrio }) {
  const {
    title,
    countryCode,
    description,
    image,
    blur,
    subdivision,
    city,
  } = destination;

  const useStyles = makeStyles()(() => ({
    card: {
      height: 300,
      boxShadow: shadow.md,
      borderRadius: 16,
    },
    content: {
      textAlign: 'center',
      position: 'absolute',
      height: '100%',
      width: '100%',
      zIndex: 20,
      top: 0,
      padding: 10,
    },
    heading: {
      textShadow: '1px 1px 10px #343A40',
      fontSize: '2.7em',
    },
    text: {
      lineHeight: '1.5em',
      maxHeight: '4.5em',
      overflow: 'hidden',
      position: 'relative',
    },
  }));
  const { classes } = useStyles();

  return (
    <>
      <Link
        href={`/destinations/${slugFromCC(countryCode)}${
          subdivision ? `/${subdivision}` : ''
        }${city ? `/${city}` : ''}`}
      >
        <Card className={classes.card}>
          <CardActionArea className="h-100 tw-group">
            <div className="tw-z-10 tw-relative tw-bg-gradient-to-t tw-from-black tw-h-full tw-w-full group-hover:tw-bg-white/25" />
            <Image
              unoptimized
              alt={nameFromCC(countryCode)}
              src={imageCrop(image, 750, 600)}
              blurDataURL={blur}
              placeholder={blur ? 'blur' : undefined}
              fill
              priority={isPrio}
              className="group-hover:tw-blur-sm tw-object-cover tw-object-center"
            />
            <div className={classes.content}>
              <div className="container h-100">
                <div className="row h-100">
                  <div className="col-12 my-auto text-light">
                    <Typography variant="h4" className={classes.heading}>
                      {title || nameFromCC(countryCode)}
                    </Typography>
                    {description && (
                      <>
                        <div className="pt-2 pb-2">
                          <CountryEmoji countryCode={countryCode} />
                        </div>
                        <Typography
                          variant="subtitle2"
                          className={classes.text}
                        >
                          {description}
                        </Typography>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </CardActionArea>
        </Card>
      </Link>
    </>
  );
}
